var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z",
    fill: "#4C60E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28125 9.71853C9.28125 8.21713 10.4984 7 11.9998 7C13.5012 7 14.7183 8.21713 14.7183 9.71853C14.7183 10.6748 14.2246 11.5157 13.4781 12.0003C12.7541 12.4704 11.9998 13.1368 11.9998 14M11.9998 17H12.0008",
    stroke: "#4C60E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorCircle);
export default __webpack_public_path__ + "static/media/vector-circle.1dd858f1f04a8fa3647c1b076b9bca38.svg";
export { ForwardRef as ReactComponent };